import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import styles from './tpcheck.module.css';
import HeaderBlack from '../../components/header/headerBlack/headerBlack';
import StatusCard from '../../components/statusCard/statusCard';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebase';

const TPCheck = () => {
  const location = useLocation();
  const { patientData, patientId } = location.state || {};
  const etapes = {
    "Lite arcade unique": 7,
    "Lite deux arcade": 7,
    "Lite": 7,

    "Essential": 12,
    "Essential deux arcade": 12,
    "Essential arcade unique": 12,

    "Smart": 24,
    "Smart deux arcade": 24,
    "Smart arcade unique": 24,

    "Pro": 36,
    "ProPlus": 36
}
const prix = {
    "Lite arcade unique": 850,
    "Lite deux arcade": 1300,
    "Lite": 850,

    "Essential": 1150,
    "Essential deux arcade": 1950,
    "Essential arcade unique": 1150,

    "Smart": 2100,
    "Smart deux arcade": 3150,
    "Smart arcade unique": 2100,

    "Pro": 4500,
    "ProPlus": 5000
}
  const [showValidateConfirm, setShowValidateConfirm] = useState(false);
  const [showRejectConfirm, setShowRejectConfirm] = useState(false);
  const [correctionText, setCorrectionText] = useState('');
  const [isCorrectionMode, setIsCorrectionMode] = useState(false);
  const [isValidated, setIsValidated] = useState(false);
  const [restrictedTeeth, setRestrictedTeeth] = useState([]);
  const [taquetTeeth, setTaquetTeeth] = useState([]);

  useEffect(() => {
    const checkValidationStatus = async () => {
      if (patientId) {
        const patientRef = doc(db, 'patients', patientId);
        const patientDoc = await getDoc(patientRef);
        if (patientDoc.exists()) {
          const data = patientDoc.data();
          setIsValidated(data.tpcheckValidated || false);
          
          // Get teeth numbers from prescription data
          if (data.prescription) {
            setRestrictedTeeth(data.prescription.selectedTeeth || []);
            setTaquetTeeth(data.prescription.taquetsTeeth || []);
          }
        }
      }
    };
    checkValidationStatus();
  }, [patientId]);

  const handleValidate = async () => {
    try {
      const patientRef = doc(db, 'patients', patientId);
      await updateDoc(patientRef, {
        tpcheckValidated: true,
        status: 3,
      
      });
      setShowValidateConfirm(false);
      navigate('/dossier', { 
        state: { 
          patient: patientData
        }
      });
    } catch (error) {
      /*console.error("Error updating patient status:", error);*/
    }
  };

  const handleReject = async () => {
    try {
      const patientRef = doc(db, 'patients', patientId);
      await updateDoc(patientRef, {
        tpcheckValidated: false,
        archived: 1,
        lastModified: new Date()
      });
      setShowRejectConfirm(false);
      navigate('/dossier', { 
        state: { 
          patient: patientData
        }
      });
    } catch (error) {
      /*console.error("Error archiving patient:", error);*/
    }
  };

  const handleCorrection = async () => {
    try {
      const patientRef = doc(db, 'patients', patientId);
      await updateDoc(patientRef, {
        status: 2,
        correction: correctionText
      });
      setIsCorrectionMode(false);
      setCorrectionText('');
      navigate('/dossier', { 
        state: { 
          patient: patientData
        }
      });
    } catch (error) {
      /*console.error("Error saving correction:", error);*/
    }
  };
  const navigate = useNavigate();

  return (
    <div>
        <HeaderBlack />
        <main>
        <StatusCard />
        <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
            <h2 className={styles.title}>TP Check</h2>
            <button className={styles.closeButton} onClick={() => navigate('/dossier', { 
                state: { 
                    patient: patientData
                }
            })}>✕</button>
        </div>
        
        {/* Main Content */}
        <div className={styles.content}>
            {/* Left Section - Doctor Info and 3D Viewer */}
            <div className={styles.mainSection}>
            {/* 3D Viewer */}
            <div className={styles.modelContainer}>
                 {/* Embedded 3D Viewer iframe */}
              <iframe 
                src={patientData.TPCheck}
                className={styles.modelIframe}
                title="3D Dental Model"
                frameBorder="0"
                allowFullScreen
              />
            </div>
                
            </div>
            
            {/* Right Section - Patient Info */}
            <div className={styles.sidebarInfo}>
            <div className={styles.infoItem}>
                <span className={styles.infoLabel}>Type de patient :</span>
                <span className={styles.infoValue}>{patientData.category}</span>
            </div>
            
            <div className={styles.infoItem}>
                <span className={styles.infoLabel}>Pack :</span>
                <span className={styles.infoValue}>{patientData.pack}</span>
            </div>
            
            {Number(patientData?.upperArcadeSteps) > 0 && (
              <div className={styles.infoItem}>
                <span className={styles.infoLabel}>Nombre d'étapes arcade supérieure :</span>
                <span className={styles.infoValue}>{patientData.upperArcadeSteps} étapes</span>
              </div>
            )}
            
            {Number(patientData?.lowerArcadeSteps) > 0 && (
              <div className={styles.infoItem}>
                <span className={styles.infoLabel}>Nombre d'étapes arcade inférieure :</span>
                <span className={styles.infoValue}>{patientData.lowerArcadeSteps} étapes</span>
              </div>
            )}
            
            <div className={styles.infoItem}>
                <span className={styles.infoLabel}>Rythme de changement :</span>
                <span className={styles.infoValue}>{patientData?.changeRhythm} jours</span>
            </div>
            
            <div className={styles.infoItem}>
                <span className={styles.infoLabel}>Devis (prix de base):</span>
                <span className={styles.infoValue}> {(patientData?.price || patientData?.baseprice )} dt Hors Taxe</span>
            </div>

            {typeof patientData?.discount !== 'undefined' && Number(patientData.discount) > 0 && (
              <>
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Remise:</span>
                  <span className={styles.infoValue}>{patientData.discount}%</span>
                </div>
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Prix avec réduction:</span>
                  <span className={styles.infoValue}>
                  {(patientData?.price ?? patientData?.baseprice) && patientData?.discount
                  ? ((patientData?.price ?? patientData?.baseprice) - ((patientData?.price ?? patientData?.baseprice) * patientData.discount / 100))
                  : (patientData?.price ?? patientData?.baseprice)}
                  dt Hors Taxe
                  </span>
                </div>
              </>
            )}
            
            {/* Action Buttons */}
            <div className={styles.actionButtons}>
                <button 
                  className={`${styles.validateButton} ${isValidated ? styles.disabled : ''}`}
                  onClick={() => setShowValidateConfirm(true)}
                  disabled={isValidated}
                >
                  Validé
                </button>
                <button 
                  className={`${styles.rejectButton} ${isValidated ? styles.disabled : ''}`}
                  onClick={() => setShowRejectConfirm(true)}
                  disabled={isValidated}
                >
                  Non Validé
                </button>
                <button 
                  className={`${styles.correctionButton} ${isValidated ? styles.disabled : ''}`}
                  onClick={() => setIsCorrectionMode(true)}
                  disabled={isValidated}
                >
                  Demander une correction
                </button>
                
                <textarea 
                  className={`${styles.correctionTextarea} ${!isCorrectionMode ? styles.disabled : ''}`}
                  placeholder="Rédigez votre texte ici"
                  value={correctionText}
                  onChange={(e) => setCorrectionText(e.target.value)}
                  disabled={!isCorrectionMode || isValidated}
                />
                <button 
                  className={`${styles.saveButton} ${!isCorrectionMode ? styles.disabled : ''}`}
                  onClick={handleCorrection}
                  disabled={!isCorrectionMode || isValidated}
                >
                  Enregistrer
                </button>
            </div>
            
            </div>
        </div>
        </div>

        {/* Validate Confirmation Popup */}
        {showValidateConfirm && (
          <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
              <h3>Êtes-vous sûr de vouloir valider ?</h3>
              <div className={styles.modalButtons}>
                <button onClick={handleValidate} className={styles.modalButton}>Oui</button>
                <button onClick={() => setShowValidateConfirm(false)} className={styles.modalButton}>Non</button>
              </div>
            </div>
          </div>
        )}

        {/* Reject Confirmation Popup */}
        {showRejectConfirm && (
          <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
              <h3>Êtes-vous sûr de vouloir ne pas valider ?</h3>
              <div className={styles.modalButtons}>
                <button onClick={handleReject} className={styles.modalButton}>Oui</button>
                <button onClick={() => setShowRejectConfirm(false)} className={styles.modalButton}>Non</button>
              </div>
            </div>
          </div>
        )}
       </main> 
    </div>
  );
};

export default TPCheck;